import BrandConfigProvider, {
  useBrandConfig
} from 'src/contexts/BrandConfigProvider';

const Auth = () => {
  const { authContent, BrandLayout } = useBrandConfig();

  return (
    <BrandLayout>
      {authContent.Title}
      {authContent.Description}
      {authContent.Provider}
    </BrandLayout>
  );
};

export const RootAuth = () => (
  <BrandConfigProvider>
    <Auth />
  </BrandConfigProvider>
);
